<!-- src/app/header/header.component.html -->
<div class="toolbar" role="banner" [ngClass]="{'root-page': isRootPage, 'hostel-page': isHostelPage, 'background-header': isBackground }" (mouseleave)="closeMenu()" #header>
  <div class="nav">
    <a class="logo" [routerLink]="['/']" aria-label="Homepage">
      <ng-container *ngIf="transparent">
        <app-logo-negative></app-logo-negative>
      </ng-container>
      <ng-container *ngIf="!transparent">
        <app-logo></app-logo>
      </ng-container>
    </a>
    <ng-container *ngIf="!headerContent">
      <div class="nav-menu" (outsideClick)="closeMenu(true)">
        <div class="nav-item" (mouseenter)="openMenu('support')" [ngClass]="{'inactive': (menuOpen | async) && (menuOpen | async) !== 'support'}">
          <span>
            <ng-container i18n>Support</ng-container>
          </span>
          <div class="nav-dropdown" *ngIf="(menuOpen | async) === 'support'" (mouseenter)="lock()" (mouseleave)="unlock()">
            <ng-container *ngFor="let item of menuItems | async">
              <a class="dropdown-item" [routerLink]="item.target" [fragment]="item.fragment" (click)="closeMenu(true)">
                <span>{{ item.label }}</span>
              </a>
            </ng-container>
          </div>
        </div>
        <div class="nav-item" (mouseenter)="openMenu('resources')" [ngClass]="{'inactive': (menuOpen | async) && (menuOpen | async) !== 'resources'}">
          <span>
            <ng-container i18n>Resources</ng-container>
          </span>
          <div class="nav-dropdown" *ngIf="(menuOpen | async) === 'resources'" (mouseenter)="lock()" (mouseleave)="unlock()">
            <ng-container *ngFor="let item of menuItems | async">
              <a class="dropdown-item" [routerLink]="item.target" (click)="closeMenu(true)">
                <span>{{ item.label }}</span>
              </a>
            </ng-container>
          </div>
        </div>
        <div class="nav-item" (mouseenter)="openMenu('about-us')" [ngClass]="{'inactive': (menuOpen | async) && (menuOpen | async) !== 'about-us'}">
          <span>
            <ng-container i18n>About us</ng-container>
          </span>
          <div class="nav-dropdown" *ngIf="(menuOpen | async) === 'about-us'" (mouseenter)="lock()" (mouseleave)="unlock()">
            <ng-container *ngFor="let item of menuItems | async">
              <a class="dropdown-item" [routerLink]="item.target" (click)="closeMenu(true)">
                <span>{{ item.label }}</span>
              </a>
            </ng-container>
          </div>
        </div>
        <!-- <div class="nav-item">
          <a [routerLink]="['/affiliate-program']" (click)="closeMenu(true)">
            <span>
              <ng-container i18n>Join our ambassador program</ng-container>
            </span>
          </a> -->
          <div class="nav-item">
            <a [routerLink]="['/ambassador-program']" (click)="closeMenu(true)">
              <span>
                <ng-container i18n>Join our ambassador program</ng-container>
              </span>
            </a>
          </div>
      </div>
    </ng-container>
    <ng-container *ngIf="headerContent">
      <ng-container *ngTemplateOutlet="headerContent"></ng-container>
    </ng-container>
  </div>

  <div class="spacer"></div>
  <div class="buttons">
    <!-- <a class="btn btn-frame login" rel="noreferrer" href="https://admin.hostelhop.io" target="_blank">
      <span>
        <ng-container i18n>Log in/Sign up</ng-container>
      </span>
    </a> -->
    <a class="btn btn-theme btn-icon btn-list-your-hostel" type="button" href="https://admin.hostelhop.io" target="_blank">
      <span style="width: 16px; height: 16px;">
        <svg width="16" height="16" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Group 104">
            <path id="Vector" d="M7.66309 9.04004V1H21.4995V20.9998H7.66309" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
            <path id="Vector_2" d="M11.8887 13.0989V21H3.4375V13.0989" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
            <path id="Vector_3" d="M1.5 15.0121L7.66366 9.03992L13.8273 15.0275" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path id="Vector_4" d="M12.6512 5.32092H11.8887V6.06165H12.6512V5.32092Z" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
            <path id="Vector_5" d="M8.04471 15.4443H7.28223V16.1851H8.04471V15.4443Z" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
            <path id="Vector_6" d="M17.2742 5.32092H16.5117V6.06165H17.2742V5.32092Z" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
            <path id="Vector_7" d="M17.2742 9.81165H16.5117V10.5524H17.2742V9.81165Z" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
            <path id="Vector_8" d="M17.2742 14.2871H16.5117V15.0278H17.2742V14.2871Z" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
          </g>
        </svg>
      </span>
      <span>
        <ng-container i18n>List your Hostel</ng-container>
      </span>
    </a>
    <app-locale-button [transparent]="transparent"></app-locale-button>
  </div>
</div>
